module.exports = __webpack_public_path__ + "static/smi6Mini-e145167b8198e7f26168e5c416791f79.png";